import { Box } from "@material-ui/core";
import BreadcrumbNav from "../../../../components/BreadcrumbNav/BreadcrumbNav";
import SalesPersonTable from "./components/SalesPersonTable/SalesPersonTable";

const SalesPersonList = () => {
  return (
    <section className="layout-dashboard-container">
      <div className="header-container">
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "10px",
          }}
        >
          <div>
            <h4 className="header-title">Lista de Asesores Externos</h4>
            <BreadcrumbNav
              firstText="Proveedor"
              secondText="Asesores Externos"
              secondLink="/proveedor/asesor/lista"
              thirdText={"Lista"}
            />
          </div>
        </Box>
      </div>
      <SalesPersonTable />
    </section>
  );
};

export default SalesPersonList;
